/**
 * Shared motion vocabulary.
 *
 * Every reveal on the site reads its timings from here so the whole page moves as
 * one system. Don't hand-roll durations or easings in components — add to this file.
 *
 * See docs/superpowers/specs/2026-08-07-motion-scroll-layer-design.md
 */

// Decelerating curve: quick departure, long settle. Calm rather than bouncy.
export const EASE = [0.22, 1, 0.36, 1];

export const DURATION = 0.55;
export const DISTANCE = 16;
export const STAGGER = 0.06;

// once: reveals never replay on scroll-back. amount: fire once a fifth is visible.
export const VIEWPORT = { once: true, amount: 0.2 };

export const revealVariants = (distance = DISTANCE, delay = 0) => ({
  hidden: { opacity: 0, y: distance },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION, ease: EASE, delay },
  },
});

export const groupVariants = (stagger = STAGGER) => ({
  hidden: {},
  visible: { transition: { staggerChildren: stagger } },
});

/**
 * Lenis tuning. `lerp` is applied per frame, so it stays consistent across refresh
 * rates. syncTouch stays off: smoothing touch fights the OS momentum scroll.
 */
export const LENIS_OPTIONS = {
  lerp: 0.1,
  smoothWheel: true,
  syncTouch: false,
};
